<template>
  <div class="ljbm">
    <div class="bm_srk">
      <textarea class="bm_srk1" id="txtRegister" v-model="classNumber" @input="setClassNumber" placeholder="请输入班号，最多支持10个班级同时报名班号之间用逗号隔开" defaultvalue="请输入班号，最多支持10个班级同时报名班号之间用逗号隔开"></textarea>
      <a @click="singUpClick" href="#" id="register" class="ljbm1">立即<br>报名</a>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  //SE18123,SE18231,SE18143
    export default{
        props: ['schoolid','classNumberData'],
        data: function () {
            return {
              classNumber:this.classNumberData
            }
        },
        methods: {

          singUpClick(){
            let classArr=[];
            let codeList=this.classNumber;
            codeList=codeList.replace(/\s/g, "").split(',');
            if(codeList==""){
              alert("请输入有效的班号。");
              return;
            }
            for (var i = 0; i < codeList.length; i++) {
              if (codeList[i] != '') {
                classArr.push(codeList[i]);
              } else {
                continue;
              }
            }
            if(classArr.length>10){
              alert("最多一次性只能报十个哦~~~");
              return;
            }


            let forI=0;

            let getsouke=()=>{

              this.$jsonp(`http://m.xdf.cn/seo/getsoukedata/index?method=Class/GetClassByCode`, {
              /*  method:'Class/GetClassByCode',*/
                schoolId:this.schoolid,
                classCode:classArr[forI],
                callbackQuery: 'callback',
                callbackName: ''
              }).then((data)=>{
                if (data['Code'] == null) {
                  alert('班号为' + classArr[forI] + '的班级不存在，请重新输入！');
                } else if (data['MaxNum'] == data['CurrentNum']) {
                  alert('班号为' + classArr[forI] + '的班级已报满，请重新输入！');
                } else if(forI+1<classArr.length){
                  ++forI
                  getsouke();
                }else {
                  window.location.href='http://bm.xdf.cn/OPXdf/Cart/AddClass?schoolId=' + this.schoolid + '&Cart=1&martSource=MSouke&classCodes=' + classArr.join(",");
                }
              },(res)=>{
                console.log(res);
              })
            }
           getsouke();

          },

          setClassNumber(){
            this.$emit('getclassnumber',this.classNumber)
          }
        },
    }
</script>
<style>

</style>



// WEBPACK FOOTER //
// components/SignUp.vue